// this middleware is used for fetching categories.json file from public/data/ 
// in future only this file will requird to change for API integration

export const getCategories = async () => {
  const response = await fetch("/data/categories.json");

  if (!response.ok) {
    throw new Error("Failed to fetch categories");
  }

  return response.json();
};
